export default {
  home: {
    minute: 'minuto',
    price_info: '{mianfei} minutos gratis, máximo por día {currencyName}{fengding}, depósito {currencyName}{yajin}, depósito de alquiler gratuito',
    feature_1: 'Diseño especial para carga inalámbrica.',
    feature_2: 'Endeudamiento y reembolso nacional universal',
    feature_3: 'Cuatro modos de carga, aptos para todos los teléfonos móviles.',
    submit: 'Recargar',
    borrow: 'Pedir prestado',
    inputcodetitle: 'Por favor ingrese el número de dispositivo en el gabinete.',
    msg_rentcount: 'Actualmente tienes {zujieNum} pedidos que no están cerrados',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    msg_fail_title: 'Error',
    msg_fail_content: 'El alquiler falló. Inténtalo de nuevo.',
    shoptime: 'Tiempo de Negocios',
    supportrental: 'Alquiler de soporte',
    supportreturn: 'Retorno de soporte',
    useragreen: 'Haga clic para aceptar el "Formulario de autorización de débito delegado", el "Acuerdo de usuario", el "Acuerdo de recarga".',
    privacyagreen: 'Haga clic para aceptar el Acuerdo de Privacidad',
    offline: 'El dispositivo {devicecode} está fuera de línea, comuníquese con el personal presente',
    permissionfail: 'Permiso denegado.',
    unbound: 'El código QR mixto {devicecode} no está vinculado al dispositivo',
    nobattery: 'No hay batería disponible en el dispositivo {devicecode}'
  },
  loginborrow: {
    perhour: "por hora",
    LANGUAGE: "IDIOMA",
    CreditCard: 'Tarjeta de crédito',
    perday: 'por día',
    max: 'máximo',
    min: 'Mín',
    per: 'por',
    you_will_be_charged: 'se le cobrará',
    powerbanktitle: 'Desbloquear el banco de energía PocktPlug',
    msg_fail_title: 'Error',
    msg_fail_user: 'Error al obtener información del usuario. ¿Quieres intentarlo de nuevo?',
    msg_rentcount: 'Actualmente tienes {zujieNum} pedidos que no están cerrados',
    msg_fail_support: 'El sistema no es compatible',
    msg_fail_confirm: 'Confirmar',
    msg_fail_retry: 'Rever',
    msg_fail_cancel: 'Cancelar',
    msg_fail_order: 'No se pudo crear la orden de arrendamiento',
    msg_fail_paymod: 'No se pudo obtener el método de pago',
    msg_fail_login: 'error de inicio de sesion',
    Apple: 'Manzana',
    otheropt: 'Otras opciones',
    selectmethod: 'selecciona tu forma de pago',
    paymentdetail: 'Detalles del método de pago',
    couponcode: 'Código promocional',
    rent: 'Confirmar pago',
    pricing: 'Ver precios',
    phone: 'Teléfono',
    Google: 'Google',
    Facebook: 'Facebook',
    loginfb: 'Iniciar sesión usando Facebook',
    logingg: 'Inicia sesión con Google',
    captcha_code: 'Código',
    phonenumber: 'Ingrese su número telefónico',
    msg_fail_code: 'Porfavor ingrese el codigo de verificacion',
    msg_fail_phone: 'Por favor, introduzca su número de teléfono',
    logout: 'Salir de cuenta',
    savenow: 'Guardar ahora',
    delete: 'Borrar',
    addcard: 'Ingrese los datos de la tarjeta',
    msg_fail_content: 'Error en el alquiler, inténtelo de nuevo',
    title: 'Por favor confirme la autorización',
    policy: 'Política.',
    term: ' Términos y condiciones',
    and: 'y',
    privacy: 'Política de privacidad.',
    tips: 'Al continuar aceptas nuestro',
    cancel: 'CANCELAR',
    agree: 'ACEPTAR'
  },
  preauth: {
    preauthortitle: 'Sobre la preautorización',
    tip1: 'Al iniciar un alquiler, se realiza una preautorización en su método de pago. Esto es sólo para garantizar que haya fondos suficientes disponibles para pagar el alquiler.',
    tip2: 'Tu banco podrá enviarte una notificación pero no es un cargo: sólo se cobrará el precio de tu alquiler.',
    tip3: "Dependiendo de su banco, el ajuste del importe en sus extractos puede tardar desde unas horas hasta unos días; esto es normal."
  },
  rentcost: {
    rentcosttitle: '¿Cuánto cuesta el alquiler?',
    tip1: 'Si no devuelve el banco de energía dentro de las 48 horas, se le cobrará una tarifa por no devolución de {currency} {yajin}.',
    tip2: 'La duración se redondea a la media hora más cercana (30 o 60 minutos)',
    tip3: 'El alquiler de un día son 24 horas desde el momento en que se contrata el power bank.',
    tip3_1: 'Se aplicará una tarifa de autorización previa de {currency}{currencyName} {cyajin} a su método de pago. Esto es para garantizar que haya fondos suficientes disponibles para pagar el alquiler.',
    tip3_2: 'Tu banco puede enviarte una notificación pero no es un cargo; sólo se cobrará el precio de su alquiler.',
    tip3_3: 'Dependiendo de su banco, el ajuste del importe en sus extractos puede tardar desde unas horas hasta unos días.',
    tip4: 'Algunos lugares pueden ofrecer algunas horas gratis o descuentos. ¡Disfrutar!',
    Days: 'Días',
    Hours: 'Horas',
    Minutes: 'Minutos'
  },
  logincode: {
    login: 'Acceso',
    retry: 'Reenviar',
    title: 'Verification code',
    subtitle: 'Ingrese el código de verificación que le enviamos a su número de teléfono'
  },
  agreenconfirm: {
    title: 'Por favor confirme la autorización',
    policy: 'Política.',
    term: "Términos y condiciones de Eternal Technology",
    and: 'y',
    privacy: 'Política de privacidad.',
    tips: 'Estoy de acuerdo',
    cancel: 'CANCELAR',
    agree: 'ACEPTAR'
  },
  users: {
    username: 'Nombre de usuario',
    mobile: 'Móvil',
    login: 'Acceso',
    orders: 'Órdenes de alquiler',
    wallet: 'Mi billetera',
    joinus: 'Cooperación para sumarse',
    langsetting: 'Ajustes de idioma'
  },
  login: {
    login_fail: 'Error de inicio de sesion',
    phonenumber: 'Número de teléfono',
    verificationcode: 'Código de verificación',
    Rentpowerbank: 'Alquilar un banco de energía',
    Rentpowerbanktip: 'Ingresa tu número de celular para comenzar',
    phone_number: 'Ingrese un número de teléfono móvil de {0} dígitos ',
    captcha_code: 'Código',
    send_code: 'Enviar código',
    login: 'Acceso',
    agree: 'Al hacer clic en Iniciar sesión, aceptas ',
    readme: `Acuerdo de usuario`,
    msg_fail_login: 'Error de inicio de sesion',
    msg_success_login: 'Inicio de sesión correcto',
    msg_success_login_code: 'Recibido con éxito, descargue la APLICACIÓN para iniciar sesión y usarla',
    msg_fail_user: 'Error al obtener información del usuario. ¿Quieres intentarlo de nuevo?',
    no_sms: 'No recibí mensaje de texto',
    retry: 'Reenviar',
    receive: 'Aplicar',
    invite_pwd: 'Código de invitación',
    vip_agreen_tip: 'Al continuar estás indicando que aceptas nuestra',
    vip_agreen_service: 'Términos de servicio',
    vip_agreen_and: 'y',
    vip_agreen_policy: 'Política de privacidad'
  },
  confirm: {
    title: 'Confirmación de pago',
    pay_label: 'Cantidad',
    addcard: 'Agregar tarjeta de billetera',
    price_tips: 'Haga clic para confirmar el pago, indicando que ha leído y aceptado las',
    price_btn: '《Acuerdo de valor añadido》',
    pay_type: 'Seleccione su método de pago preferido',
    submit: 'Confirmar contrato de arrendamiento',
    charge: 'Confirmar recarga',
    msg_fail_title: 'Advertencia',
    msg_fail_order: 'Error al crear la orden de arrendamiento',
    msg_fail_confirm: 'Confirmar',
    msg_fail_retry: 'Rever',
    msg_fail_cancel: 'Cancelar'
  },
  join: {
    title: 'Camaradería',
    call: 'Llamar',
    tips: '¡Por favor proporcione su información, nos comunicaremos con usted en breve!',
    type1: 'Instalación',
    type2: 'Publicidad',
    type3: 'Otro',
    shop_name: 'Nombre del comerciante',
    contact_person: 'Persona de contacto',
    phone: 'Número de contacto',
    submit: 'Envío',
    noempty: 'No puede estar vacío'
  },
  mine: {
    title: 'Perfil del usuario',
    wallet: 'Mi billetera',
    balance: 'Mi balance',
    mywalletcard: 'Mi tarjeta',
    addcard: 'Agregar tarjeta de billetera',
    deposit: 'Depósito',
    wallet_in: 'Cargar',
    wallet_out: 'Retirar',
    wallet_log: 'Registro de billetera',
    order: 'Orden',
    login_tips: 'Por favor Iniciar sesión',
    msg_fail_title: 'Error',
    msg_fail_user: 'Error al obtener información del usuario. ¿Quieres intentarlo de nuevo?',
    help: 'Ayuda',
    setting: 'Configuración',
    logout: 'Cerrar sesión',
    unpaid: 'No pagado',
    using: 'En uso'
  },
  msg: {
    nopaymode: 'Error en la adquisición del método de pago',
    unlogin: 'Aún no has iniciado sesión, inicia sesión',
    msg_fail_title: 'Advertencia',
    deletecard: '¿Estás seguro de eliminar esta tarjeta?',
    loading: 'Cargando...',
    title: 'Consejos',
    success: 'Operación exitosa',
    error: 'Error desconocido, inténtelo de nuevo más tarde.',
    userinfo_fail: 'La información del usuario no es válida, inicie sesión nuevamente',
    roleerror: 'Permisos insuficientes, consulte al administrador',
    neterror: 'Error en la conexión de red. Por favor, inténtelo de nuevo más tarde',
    confirm: 'Confirmar',
    retry: 'Rever',
    cancel: 'Cancelar',
    msg_logout: '¿Estás seguro de salir de la cuenta?',
    vieworder: 'Ver pedido',
    addorselectcard: 'Agregue o seleccione un paquete de tarjetas para continuar',
    success_payment: 'Pago completado',
    fail_payment: 'Error en el pago',
    keyword: 'palabra clave',
    unpaid_order: 'Hay pedidos impagos',
    go_pay: 'Ve a pagar',
    no_more: 'no más',
    noshop: 'Sin comerciantes',
    msg_fail_code: 'Porfavor ingrese el codigo de verificacion',
    msg_fail_phone: 'Por favor, introduzca su número de teléfono',
    exceedorder: 'Ya tienes un pedido en arrendamiento, por favor devuélvelo antes de continuar'
  },
  result: {
    title: 'Alquiler confirmado',
    tips: 'Para ver pedidos y otras ubicaciones de estaciones, descargue la aplicación.',
    download: 'DESCARGAR',
    vieworder: 'Ver pedido',
    msg_result_loading: 'El resultado del pago está siendo confirmado...',
    msg_tips_loading: 'La batería portátil está apareciendo, espere pacientemente...',
    haveorder: 'Se ha generado orden oficial'
  },
  result_msg: {
    loading: 'Cargando...',
    refresh: 'Actualizar'
  },
  order: {
    title: 'Orden de arrendamiento',
    in_use: 'En uso',
    ended: 'Terminado',
    msg_error: 'Solicitud fallida',
    no_data: 'No Data'
  },
  order_item: {
    order_number: 'No.',
    venue_rented: 'Lugar alquilado',
    time_rented: 'Tiempo alquilado',
    venue_returned: 'Lugar devuelto',
    time_returned: 'El tiempo volvió',
    charge_standard: 'Estándar de carga',
    rent_occurred: 'Se produjo el alquiler',
    returned: 'Regresado',
    unreturned: 'No devuelto',
    type_0: 'Sin completar',
    type_1: 'Alquiler',
    type_2: 'Cancelado',
    type_3: 'Regresado',
    type_4: 'Ocurrió una falla',
    type_5: 'Con el tiempo',
    min: 'Mín',
    unpaid: 'No pagado',
    payment: 'Pago'
  },
  setting: {
    title: 'Configuración',
    lang: 'Idioma'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Añadir valor',
    price_label: 'Seleccione otro monto de recarga',
    price_placeholder: 'por favor ingrese el monto de la recarga',
    balance: 'Balance',
    chargemoney: 'Por favor seleccione la cantidad de recarga',
    submit: 'Entregar',
    loading: 'Cargando ...',
    msg_title: 'Recordatorio'
  },
  wallet_out: {
    title: 'Retiro',
    price_label: 'Por favor ingrese el monto del retiro',
    price_placeholder: 'Por favor ingrese el monto del retiro',
    balance: 'Saldo actual',
    balance_all: 'Retirar todo',
    deposit: 'Depósito',
    deposit_tips: 'Hay una orden de arrendamiento. El depósito de {pcurrencyName}{pyajin} no es reembolsable',
    submit: 'Entregar',
    apply: 'Aplicar',
    confirm: 'Confirmar',
    loading: 'Cargando...',
    msg_fail_price: 'El monto del retiro es incorrecto',
    msg_fail_balance: 'El monto del retiro no puede ser mayor que el saldo actual',
    msg_title: 'Error',
    msg_success_content: 'Aplicar reembolso exitoso',
    tips_title: 'Explicación',
    btn: 'Entregar',
    error_tips: 'Por favor ingrese la información completa'
  }
}
